<!--
 * @Autor        : sandyWqh
 * @Date         : 2023-01-17 11:16:35
 * @Description  : 
 * @Version      : 1.0
 * @LastEditors  : sandyWqh
 * @LastEditTime : 2023-01-31 16:29:47
-->
<template>
  <div class="el-tabs--border-card border_card">
    <div class="el-tabs__header tab_header">
      <div class="el-tabs__nav-wrap">
        <div class="el-tabs__nav-scroll">
          <div role="tablist" class="el-tabs__nav is-stretch">
            <div class="el-tabs__item tab_item" :class="selected == '/aboutus' ? 'selected' : ''">
              <router-link to="/aboutus">{{ $t("langs.companyIntroduction") }}</router-link>
            </div>
            <div
              class="el-tabs__item tab_item border-add"
              :class="selected == '/onlineEnquiry' ? 'selected' : ''"
            >
              <router-link to="/onlineEnquiry">{{ $t("langs.onlineEnquiry") }}</router-link>
            </div>
            <div
              class="el-tabs__item tab_item"
              :class="selected == '/cooperateChain' ? 'selected' : ''"
            >
              <router-link to="/cooperateChain">{{ $t("langs.cooperateChain") }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tab",
  data() {
    return {
      selected: this.$route.path || "/aboutus"
    };
  },
  methods: {
    handleRewrite(path) {
      this.$router.push(path);
    }
  }
};
</script>
<style scoped>
.border_card {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
  border-left: none !important;
  border-right: none !important;
}
.tab_header {
  background-color: #d3ddeb !important;
  border-left: 1px solid #e4e7ed !important;
  border-right: 1px solid #e4e7ed !important;
}
.border-add {
  border-right: 1px solid #ffffff !important;
  border-left: 1px solid #ffffff !important;
}
.tab_item {
  font-size: 24px !important;
  height: 48px !important;
  line-height: 48px;
}
.selected {
  color: #00d265 !important;
  background-color: #fff;
  border-right-color: #dcdfe6;
  border-left-color: #dcdfe6;
}
</style>


// WEBPACK FOOTER //
// src/components/about/tab.vue